import { render, staticRenderFns } from "./BubbleVis.vue?vue&type=template&id=586593e0&scoped=true&"
import script from "./BubbleVis.vue?vue&type=script&lang=js&"
export * from "./BubbleVis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586593e0",
  null
  
)

export default component.exports